import { triggerToastNotify } from '@/components/Toast'
import { useDocumentStore } from '@/features/document/store'
import { queryClient } from '@/lib/queryClient'
import { NotificationType } from '@/schema/notification'

import { notificationApi } from '../services'
import { useNotificationDrawerStore } from '../store'
import { NotificationMetadata } from '../types'

import { createNotificationNavigationHandler } from './navigationHandler'

export const triggerNotificationToast = (
  title: string,
  message: string,
  navigate: (
    path: string,
    options?: { state?: Record<string, unknown> }
  ) => void,
  notificationId?: string,
  metadata?: NotificationMetadata,
  notificationType?: NotificationType
) => {
  const { isMuted } = useNotificationDrawerStore.getState()

  // Only show toast if not muted
  if (!isMuted) {
    // Create navigation handler if we have notification data
    let onClick: (() => void) | undefined

    if (notificationId && metadata && notificationType) {
      const { setOpenDocument, setActiveDocumentId } =
        useDocumentStore.getState()
      const { closeDrawer, isPinned } = useNotificationDrawerStore.getState()

      onClick = createNotificationNavigationHandler(
        metadata,
        notificationType,
        {
          navigate,
          setOpenDocument,
          setActiveDocumentId,
          closeDrawer: isPinned ? () => {} : closeDrawer,
          markAsRead: async () => {
            await notificationApi.markAsRead(notificationId)
            queryClient.invalidateQueries({
              queryKey: ['notifications'],
            })
          },
        }
      )
    }

    triggerToastNotify({ title, message, onClick })
  }
}
